<template>
	<div
		class="container__switcher"
		:class="{ disabled }"
		data-testid="switcher-component"
	>
		<label
			v-if="leftLabel"
			style="margin-right: 0.5rem"
			:class="{ 'font-semibold': !model }"
			class="text-s"
			:for="label"
			>{{ leftLabel }}</label
		>
		<div class="container__swicher__checkbox">
			<input
				:id="label"
				v-model="model"
				class="cursor-pointer"
				:class="{ dual__option: leftLabel && label }"
				type="checkbox"
				:disabled="disabled"
			/>
		</div>
		<label
			:class="{ active: model }"
			class="text-s"
			:for="label"
			>{{ label }}</label
		>
	</div>
</template>

<script setup>
import { computed, toRefs } from 'vue'

const emit = defineEmits(['input'])

const props = defineProps({
	label: String,
	leftLabel: String,
	disabled: Boolean,
	value: {
		type: Boolean,
		default: false,
	},
})

const { label, leftLabel, disabled } = toRefs(props)

const model = computed({
	get() {
		return props.value
	},
	set(value) {
		emit('input', value)
	},
})
</script>

<style scoped>
.container__switcher {
	@apply gap-2;
	display: flex;
	/* gap: 1rem; */
	align-items: center;
	user-select: none;
}

.container__switcher.disabled {
	@apply opacity-40 !cursor-not-allowed;
}

.container__switcher label {
	@apply font-normal text-base text-[#464947];
}

.container__swicher__checkbox {
	display: flex;
	position: relative;
}

input[type='checkbox'] {
	cursor: pointer;
	height: 20px;
	width: 45px;
	background-color: #b9baba;
	appearance: none;
	outline: none;
	border-radius: 100px;
	transition: all 0.1s linear;
}

input[type='checkbox'].dual__option {
	background-color: #b9baba;
}

input[type='checkbox']:disabled {
	background-color: #b9baba;
}

input:checked[type='checkbox'] {
	background-color: #34617e;
}

input:checked[type='checkbox']:disabled {
	background-color: #67889e;
}

input[type='checkbox']:before {
	position: absolute;
	content: '';
	right: 25px;
	height: 20px;
	width: 20px;
	border-radius: 50%;
	background-color: white;
	border: 1px solid #34617e;
	transition: right 0.1s linear;
}

input:checked[type='checkbox']:before {
	right: 0;
}

label.active {
	@apply font-semibold;
}
</style>
